import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Wrapper,
  ArticleImage,
  BottomSection,
  ArticleTitle,
  ArticleScore,
  CarouseLWrapper,
  Title,
} from './Learning.styled';

export const Card = ({ itemData, cardNavigatePath, showScores }) => {
  const navigate = useNavigate();
  const scoreHundredVersion = Math.floor(itemData.bestScore * 100);
  return (
    <Wrapper
      className="item"
      onClick={() => {
        navigate(`${cardNavigatePath}/${itemData.id}`);
      }}
    >
      <ArticleImage>
        <img src={itemData.pictureUrl} />
      </ArticleImage>
      <BottomSection>
        <ArticleTitle>{itemData.label}</ArticleTitle>
        {itemData.bestScore !== null && showScores && (
          <ArticleScore>
            <div className="score-title">BEST SCORE</div>
            <div
              className={`score-body ${
                scoreHundredVersion > 79
                  ? 'green'
                  : scoreHundredVersion > 59
                    ? 'yellow'
                    : 'red'
              }`}
            >
              {scoreHundredVersion}.0%
            </div>
          </ArticleScore>
        )}
      </BottomSection>
    </Wrapper>
  );
};

const Carousel = ({ data, cardNavigatePath, showScores = false }) => {
  const modules = data.modules;
  return (
    <CarouseLWrapper>
      <Title>
        {data.name} ({modules.length})
      </Title>
      <AliceCarousel
        paddingRight={75}
        autoWidth={true}
        disableDotsControls={true}
        disableButtonsControls={true}
        mouseTracking={true}
        items={modules.map((item, i) => {
          const module = data.name;
          const suggestions = [
            modules[(i + 1) % modules.length],
            modules[(i + 2) % modules.length],
          ];
          return (
            // tslint:disable-next-line:jsx-key
            <Card
              itemData={{ ...item, module, suggestions }}
              cardNavigatePath={cardNavigatePath}
              showScores={showScores}
            />
          );
        })}
      />
    </CarouseLWrapper>
  );
};

export default Carousel;
